export default "__VITE_ASSET__CyvL_1wU__"